import { Loader2, XCircle } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';

interface ForceFailMigrationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  migrationName: string;
  onConfirm: () => void;
  isForcing: boolean;
}

export function ForceFailMigrationDialog({
  open,
  onOpenChange,
  migrationName,
  onConfirm,
  isForcing,
}: ForceFailMigrationDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[450px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-destructive">
            <XCircle className="h-5 w-5" />
            Force Fail Migration
          </DialogTitle>
          <DialogDescription>
            You are about to force-fail the migration for{' '}
            <span className="font-medium text-foreground">{migrationName}</span>.
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <Alert variant="destructive">
            <XCircle className="h-4 w-4" />
            <AlertDescription>
              <ul className="mt-1 list-disc list-inside text-sm space-y-1">
                <li>This will immediately mark the migration and all pending modules as Failed.</li>
                <li>This action cannot be undone. Use only when the migration is confirmed stuck.</li>
              </ul>
            </AlertDescription>
          </Alert>
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isForcing}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isForcing}
          >
            {isForcing && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Force Fail
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
